"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelStyle = exports.TabContentStyle = exports.GetTabLabelContainerStyles = exports.TabStyleName = exports.DefaultTabLabelStyleName = exports.GetTabListStyles = exports.TabPanelContainerStyles = exports.TabPanelScrollContainerStyles = exports.RootStyleName = exports.NonAnchorTabPanelStyles = exports.TabsWidgetDimensions = exports.Hidden = exports.Visible = void 0;
var tslib_1 = require("tslib");
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var FocusIndicators_1 = require("../../styles/FocusIndicators");
var PreventUserSelect_1 = require("../../styles/PreventUserSelect");
var TextEllipsis_1 = require("../../styles/TextEllipsis");
// Only the active tab should be visible, all others should be hidden
exports.Visible = { visibility: 'visible' };
exports.Hidden = { visibility: 'hidden' };
var TabIndicatorHeight = 3;
exports.TabsWidgetDimensions = {
    tabLabelPadding: 24,
    textOnlyTabListHeight: 39 + TabIndicatorHeight,
    iconAndTextTabListHeight: 51 + TabIndicatorHeight,
    tabIndicatorHeight: TabIndicatorHeight,
};
var FocusIndicatorOffset = FocusIndicators_1.FocusIndicatorWidth + FocusIndicators_1.FocusIndicatorInsetWidth;
var BackgroundColors = {
    Active: '#c9c9c9',
    Default: 'transparent',
    Hover: '#e5e5e5',
};
var IndicatorColors = {
    Active: '#2e2e2e',
    Default: '#c9c9c9',
    Hover: '#444',
    Selected: '#5c5c5c',
};
// The client specifies which tab panel we should anchor the tab widget height to. It's often the tallest tab panel,
// so that the dialog will always be tall enough and will not resize when switching tabs
exports.NonAnchorTabPanelStyles = {
    position: 'absolute',
    width: '100%',
    left: '0',
    top: '0'
};
exports.RootStyleName = TypeStyle.style({
    display: 'flex',
    flexDirection: 'column',
});
var TabPanelScrollContainerStyles = function (padding) { return ({
    overflowY: 'auto',
    padding: padding !== null && padding !== void 0 ? padding : 18,
    position: 'relative',
    WebkitOverflowScrolling: 'touch',
}); };
exports.TabPanelScrollContainerStyles = TabPanelScrollContainerStyles;
exports.TabPanelContainerStyles = {
    position: 'relative',
};
var GetTabListStyles = function (isAnIconDefinedInTabs, tabHeightOverride) {
    return tslib_1.__assign({ display: 'flex', flexShrink: 0, fontSize: 12, height: tabHeightOverride !== null && tabHeightOverride !== void 0 ? tabHeightOverride : (isAnIconDefinedInTabs ? exports.TabsWidgetDimensions.iconAndTextTabListHeight : exports.TabsWidgetDimensions.textOnlyTabListHeight) }, PreventUserSelect_1.PreventUserSelect);
};
exports.GetTabListStyles = GetTabListStyles;
exports.DefaultTabLabelStyleName = TypeStyle.style(tslib_1.__assign({ color: '#2e2e2e', width: '100%' }, TextEllipsis_1.TextEllipsis));
exports.TabStyleName = TypeStyle.style({
    backgroundColor: BackgroundColors.Default,
    boxSizing: 'border-box',
    display: 'inline-block',
    height: '100%',
    overflow: 'hidden',
    position: 'relative',
    $nest: (_a = {
            '&:hover': { backgroundColor: BackgroundColors.Hover },
            '&:active': { backgroundColor: BackgroundColors.Active },
            '&::after': {
                backgroundColor: IndicatorColors.Default,
                content: "\"\"",
                height: exports.TabsWidgetDimensions.tabIndicatorHeight,
                position: 'absolute',
                bottom: 0,
                left: 0,
                right: 0,
            },
            '&:hover::after': { backgroundColor: IndicatorColors.Hover },
            '&[aria-selected="true"]::after': { backgroundColor: IndicatorColors.Selected },
            '&:active::after': { backgroundColor: IndicatorColors.Active },
            // Everything except for the bottom outline of the focus indicator should be "inset".
            // The bottom outline should be offset with a 1px gap.
            // Since there is no way to set outline-offset for just the bottom, need to hack this
            // behavior by increasing the height and shifting the tab indicator upwards
            '&:focus-visible': tslib_1.__assign(tslib_1.__assign({}, FocusIndicators_1.DefaultFocusIndicator()), { borderRadius: 2, height: "calc(100% + " + FocusIndicatorOffset + "px)" })
        },
        _a["&:focus-visible ." + exports.DefaultTabLabelStyleName] = {
            marginTop: -FocusIndicatorOffset, // adjusting the height of the tab causes the text to shift
        },
        _a['&:focus-visible::after'] = {
            bottom: FocusIndicatorOffset,
            left: FocusIndicatorOffset,
            right: FocusIndicatorOffset,
        },
        _a)
});
var GetTabLabelContainerStyles = function (horizontalPadding) {
    return {
        alignItems: 'center',
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        paddingRight: horizontalPadding !== null && horizontalPadding !== void 0 ? horizontalPadding : exports.TabsWidgetDimensions.tabLabelPadding,
        paddingLeft: horizontalPadding !== null && horizontalPadding !== void 0 ? horizontalPadding : exports.TabsWidgetDimensions.tabLabelPadding,
    };
};
exports.GetTabLabelContainerStyles = GetTabLabelContainerStyles;
exports.TabContentStyle = {
    alignItems: 'center',
    display: 'flex',
    gap: 8,
    justifyContent: 'center'
};
exports.LabelStyle = tslib_1.__assign({ display: 'block' }, TextEllipsis_1.TextEllipsis);
//# sourceMappingURL=TabsWidgetStyles.js.map